/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Permissions_Entity_ScopeInputs */

const en_tables_permissions_entity_scope = /** @type {(inputs: Tables_Permissions_Entity_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity Scope`)
};

const de_tables_permissions_entity_scope = /** @type {(inputs: Tables_Permissions_Entity_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitätsbereich`)
};

/**
* | output |
* | --- |
* | "Entity Scope" |
*
* @param {Tables_Permissions_Entity_ScopeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_permissions_entity_scope = /** @type {((inputs?: Tables_Permissions_Entity_ScopeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Permissions_Entity_ScopeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_permissions_entity_scope(inputs)
	return de_tables_permissions_entity_scope(inputs)
});